<template>
    <div class="tw-flex tw-flex-wrap md:tw-justify-center tw-items-top">
        <div :class="{
            'tw-px-2 tw-w-full md:tw-w-1/5': true,
        }">
            <div :class="{
                'form-input': true,
            }">
                <label for="search_type">
                    <span>I want to find...</span>
                </label>
                <select id="search_type" v-model="state.searchType" name="search_type">
                    <option v-if="state.showFittingLocations" value="fittinglocation">
                        Fitting Location
                    </option>
                    <option v-if="state.canBookOnline" value="fittingevent">
                        Fitting Event
                    </option>
                    <option v-if="allowRetailerSearch" value="retailer">
                        Retailer
                    </option>
                </select>
            </div>
        </div>

        <div v-if="state.appRegion == 'eu'" class="tw-px-2 tw-w-full md:tw-w-1/5">
            <div class="form-input">
                <label for="country_code">
                    <span>Country</span>
                </label>
                <select id="country_code" v-model="state.countryCode" name="country_code">
                    <option value="AD">
                        Andorra
                    </option>
                    <option value="AT">
                        Austria
                    </option>
                    <option value="BE">
                        Belgium
                    </option>
                    <option value="CY">
                        Cyprus
                    </option>
                    <option value="CZ">
                        Czech Republic
                    </option>
                    <option value="DK">
                        Denmark
                    </option>
                    <option value="EE">
                        Estonia
                    </option>
                    <option value="FI">
                        Finland
                    </option>
                    <option value="FR">
                        France
                    </option>
                    <option value="DE">
                        Germany
                    </option>
                    <option value="GR">
                        Greece
                    </option>
                    <option value="GG">
                        Guernsey
                    </option>
                    <option value="IS">
                        Iceland
                    </option>
                    <option value="IE">
                        Ireland
                    </option>
                    <option value="IT">
                        Italy
                    </option>
                    <option value="JE">
                        Jersey
                    </option>
                    <option value="LT">
                        Lithuania
                    </option>
                    <option value="LU">
                        Luxembourg
                    </option>
                    <option value="MT">
                        Malta
                    </option>
                    <option value="MA">
                        Morocco
                    </option>
                    <option value="NL">
                        Netherlands
                    </option>
                    <option value="NO">
                        Norway
                    </option>
                    <option value="PO">
                        Poland
                    </option>
                    <option value="PT">
                        Portugal
                    </option>
                    <option value="SK">
                        Slovakia
                    </option>
                    <option value="ES">
                        Spain
                    </option>
                    <option value="CH">
                        Switzerland
                    </option>
                    <option value="SE">
                        Sweden
                    </option>
                    <option value="TR">
                        Turkey
                    </option>
                    <option value="GB">
                        United Kingdom
                    </option>
                </select>
            </div>
        </div>

        <div :class="{
            'tw-px-2  tw-w-1/2 md:tw-w-1/5': true,
        }">
            <div class="form-input">
                <label for="search_code">
                    <span>{{ postalCodeName }} Code</span>
                </label>
                <input id="search_code" v-model="state.searchPostalCode" class="tw-w-full" type="text" name="search_code" @keyup.enter="search">
            </div>
        </div>

        <div :class="{
            'tw-px-2 tw-w-1/2 md:tw-w-1/5': true,
        }">
            <div class="form-input">
                <label for="search_distance">
                    <span>Distance</span>
                </label>
                <select id="search_distance" v-model="state.searchDistance" name="search_distance">
                    <option value="25">
                        25 {{ state.distancePref }}
                    </option>
                    <option value="50">
                        50 {{ state.distancePref }}
                    </option>
                    <option value="75">
                        75 {{ state.distancePref }}
                    </option>
                    <option value="150">
                        150 {{ state.distancePref }}
                    </option>
                </select>
            </div>
        </div>

        <div :class="{
            'tw-px-2 md:tw-pt-2 tw-w-full md:tw-w-auto': true,
        }">
            <button :class="{
                        'submit-btn btn btn-primary': true,
                        'sl-disabled': !state.searchPostalCode || state.shouldDisableSearchButton,
                    }"
                    :disabled="!state.searchPostalCode || state.shouldDisableSearchButton"
                    @click="search">
                Search
            </button>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        allowRetailerSearch: function () {
            if ('allowRetailer' in window.LocatorConfig) return window.LocatorConfig.allowRetailer;

            return true;
        }
    },
    methods: {
        search () {
            this.$emit('search');
        }
    }
};
</script>

<style scoped>
.sl-flex {
        justify-content: center;
        display: flex;
        flex-wrap:  wrap;
}
@media (min-width: 1024px) {
    .sl-flex {

    }
}

.sl-col {
    width: 50%;
    padding-left: 8px;
    padding-right: 8px;
    margin-bottom: 8px;
}
@media (min-width: 1024px) {
    .sl-col {
        width: auto;
        margin-bottom: 0;
    }
}

.sl-col label {
    margin-right: 8px;
    margin-bottom: 0;
}
.sl-disabled {
    opacity: .2;
}
.form-input {

    padding: 2px;
    position: relative;

}
.form-input label {
    padding: 0 2px;
    font-size: 11px;
}
.form-input select {
    border: solid 1px #999;
    display: block;
    padding: 10px 60px 10px 10px;
    height: 50px;
    border-radius: 0;
    background: none;
    width: 100%;
    appearance: none;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: calc(100% - 5px);
    background-position-y: 10px;
}
.form-input input {
    display: block;
    padding: 5px 10px;
    border-radius: 0;
    background: none;
    appearance: none;
    height: 50px;
    border: solid 1px #999;
}
.submit-btn {
    background: #333;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
    appearance: none;
    border: none;
    padding: 0 10px;
    height: 50px;
    width: 100%;
    margin-top: 26px;
    font-weight: 500px;
}
@media (min-width: 1024px) {
    .submit-btn {
        width: auto;
    }
}
</style>
